export default __webpack_public_path__ + "static/media/power.0d4a9472.svg";